module.exports = __webpack_public_path__ + "eb558635d6181e635e1fea81f6e4f555.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Avatar_Eco8_weiss@2x.png
// module id = 261
// module chunks = 0